import {
  Form,
  PlayerPortalsForm,
} from '@r-and-a-shared-ui/common-forms-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: () => PlayerPortalsForm,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.Form) =>
    kontentAiDataMapping.player_portals_form(
      entry as PLAYER_PORTALS_MODELS.Form,
    ),
  depthParameter: 4,
};
